import type { AxiosRequestConfig } from 'axios';

// axios@0.33 typed `AxiosRequestConfig['headers']` as optional (it was
// required pre-0.33), so it must be initialized before a caller writes to
// it. Centralized here so every request interceptor that needs to set a
// header doesn't carry its own copy of this axios-version-specific guard.
export const ensureRequestHeaders = <
  T extends { headers?: AxiosRequestConfig['headers'] },
>(
  config: T,
): NonNullable<T['headers']> => {
  config.headers = config.headers ?? ({} as NonNullable<T['headers']>);
  return config.headers as NonNullable<T['headers']>;
};
